import { CapabilityDetail } from "./capability-detail.model";

export class ReleaseDetail {
    capabilityDetails: CapabilityDetail[];

    constructor() {
        this.capabilityDetails = [new CapabilityDetail()];
    }
}